import * as Utils from 'Assets/Utils'
import { isLoading } from 'Modules/Loading'
import { createModal } from 'Modules/Modal'
import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'

const initialState = Immutable.Map({})
	.set('Search', new Immutable.List([]))
	.set('Response', new Immutable.Map({}))
	.set('Get', new Immutable.Map({oportunidades: {oportunidad: []}}))

/* Types */
export const GET_OPORTUNITIES = 'GET_OPORTUNITIES'
export const SET_CORRIDA = 'SET_CORRIDA'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_OPORTUNITIES:
			return state.set('Get', new Immutable.Map(action.Obj))
		case SET_CORRIDA:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getOportunities = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getOportunities',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false));
			dispatch({type: GET_OPORTUNITIES, Obj: response.data})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const applyOportunity = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/applyOportunity',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setIdCorrida = (selection) => {
	return (dispatch) => {
		dispatch({type: SET_CORRIDA, Obj: {...selection}})
		return Promise.resolve()
	}
}

export const clearCorrida = () => {
	return (dispatch) => {
		dispatch({ type: SET_CORRIDA, Obj: {} })
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Opportunities/Opportunities.js